import { render, staticRenderFns } from "./UploadProductsByXML.vue?vue&type=template&id=1f22a2a6&"
import script from "./UploadProductsByXML.vue?vue&type=script&lang=js&"
export * from "./UploadProductsByXML.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports